// extracted by mini-css-extract-plugin
export default {"SideBarNavItem":"C2Wj68Sf"};